document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pw-faq').forEach(function (section) {
    var toggles = section.querySelectorAll('[data-pw-faq-toggle]');

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var item = toggle.closest('.pw-faq__item');
        var answer = item.querySelector('[data-pw-faq-answer]');
        var isOpen = item.classList.contains('is-open');

        section.querySelectorAll('.pw-faq__item.is-open').forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            openItem.querySelector('[data-pw-faq-toggle]').setAttribute('aria-expanded', 'false');
            openItem.querySelector('[data-pw-faq-answer]').setAttribute('hidden', '');
          }
        });

        if (isOpen) {
          item.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          answer.setAttribute('hidden', '');
        } else {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          answer.removeAttribute('hidden');
        }
      });
    });
  });
});